module.exports = __webpack_public_path__ + "img/5cf1b12.jpg";